import { gql } from '@apollo/client';

// Matches the backend mutation definition
const CREATE_PRODUCT_WORK_AND_FORMAT_MUTATION = gql`
  mutation CreateProductWorkAndFormat(
    $productWorkInput: ProductWorkInput!,
    $productInput: ProductInput!,
    $creatorsInput: [CreatorInput]
  ) {
    createProductWorkAndFormat(
      productWorkInput: $productWorkInput,
      productInput: $productInput,
      creatorsInput: $creatorsInput
    ) {
      ok
      message
      productWork {
        id
        title
        # Include other fields needed for immediate feedback or update
        products {
          id # Include the ID of the newly created product format
          isbn
          format {
             id
             description
          }
        }
      }
    }
  }
`;

export default CREATE_PRODUCT_WORK_AND_FORMAT_MUTATION;
